import React from "react";
import { object } from "prop-types";

import ComponentContainer from "../../layouts/component-container";
import NumberedHeadline from "../../molecules/NumberedHeadline";
import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import CustomSlider from "../../atoms/CustomSlider";

import { useDevice } from "../../utils/react-utils";

import "./numbered5Stories.m.css";

const Numbered5Stories = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;
  const { mobile } = useDevice();

  const { items } = collection;
  const stories = [];
  items.forEach((item) => item.type === "story" && stories.push(item.story));

  if (!stories.length) {
    return null;
  }

  return (
    <ComponentContainer styleName="wrapper" collection={collection}>
      {mobile !== undefined &&
        (mobile ? (
          <CustomSlider
            isNavigation={false}
            slidesPerView={{ mobileSlides: 1.2, tabSlides: 1.2 }}
            spacing={{ mobileSpace: 16, tabSpace: 16 }}
            isNoPaddingMobile={true}
          >
            {stories.map((story, index) => (
              <Organism1 story={story} key={index} headlineNumber={index + 1} showImage={true} />
            ))}
          </CustomSlider>
        ) : (
          <div styleName="grid-container">
            <div styleName="first-card">
              <Organism2 story={stories[0]} headlineNumber={1} />
            </div>
            <div styleName="grid-container">
              {stories.slice(1, 5).map((story, index) => (
                <NumberedHeadline
                  key={index}
                  styleName="numbered-headline"
                  story={story}
                  headlineNumber={index + 2}
                  iconEnd={true}
                />
              ))}
            </div>
          </div>
        ))}
    </ComponentContainer>
  );
};

Numbered5Stories.propTypes = {
  collection: object.isRequired,
};

Numbered5Stories.storyLimit = 5;

export default Numbered5Stories;
